export const isServiceInSuccessNetwork = (service) => service.serviceCategories.indexOf('successNetwork') !== -1

export const isServiceInOtherSection = (service) =>
  service.serviceCategories.indexOf('serviceCatalog') !== -1 &&
  service.serviceCategories.indexOf('successNetwork') === -1
